import React from "react";
import Nav from "react-bootstrap/Nav";

export const CustomTabs = ({ activeKey, setActiveKey }) => {
  const handleSelect = (eventKey) => {
    setActiveKey(eventKey);
  };

  return (
    <Nav variant="tabs" activeKey={activeKey} onSelect={handleSelect}>
      <Nav.Item>
        <Nav.Link eventKey="ransomware">{`Ransomware`}</Nav.Link>
      </Nav.Item>
      <Nav.Item>
        <Nav.Link eventKey="cybercrime">{`Cybercrime`}</Nav.Link>
      </Nav.Item>
    </Nav>
  );
};
